import React, { memo } from 'react'
import TodoList from '../../components/todos/TodoList'
import PageTemplate from './PageTemplate'
import LOG from '../../logging/Logger'

export default memo(
  ({
    list,
    scrollRef = null,
    current = true,
    future = false,
    draggable = true,
    sortBy = null,
    showAdd = true,
    showZen = true,
    hasStatus = true,
    hasList = true,
    deleteTodo,
    getTodos,
    moveTodoToTrash,
    decrypt,
    editTodoStatus,
    getRepeatPattern,
    getProjectNameForTodo,
    redirectToProject,
    getProjectsForAreas,
    clientId,
    createProject,
    getProjectById,
    editTodo,
    getAvailableTags,
    createTodo,
    getAreas,
    getTagsFromTodo,
    createAttachment,
    deleteAttachment,
    editAttachment,
    downloadAttachment,
    getTodoAttachments,
    cacheDragList,
    setInfo,
    setWarning,
    setError,
    getAreaById
  }) => {
    LOG.debug('Render: ListPageTemplate')

    return (
      <PageTemplate
        list={list}
        future={future}
        draggable={draggable}
        sortyBy={sortBy}
        showZen={showZen}
        deleteTodo={deleteTodo}
        getTodos={getTodos}
        moveTodoToTrash={moveTodoToTrash}
        getAvailableTags={getAvailableTags}
      >
        <TodoList
          list={list}
          scrollRef={scrollRef}
          current={current}
          future={future}
          draggable={draggable}
          sortBy={sortBy}
          showAdd={showAdd}
          showZen={showZen}
          hasStatus={hasStatus}
          hasList={hasList}
          getTodos={getTodos}
          decrypt={decrypt}
          editTodoStatus={editTodoStatus}
          getRepeatPattern={getRepeatPattern}
          getProjectNameForTodo={getProjectNameForTodo}
          redirectToProject={redirectToProject}
          getProjectsForAreas={getProjectsForAreas}
          clientId={clientId}
          createProject={createProject}
          deleteTodo={deleteTodo}
          getProjectById={getProjectById}
          editTodo={editTodo}
          getAvailableTags={getAvailableTags}
          createTodo={createTodo}
          getAreas={getAreas}
          getTagsFromTodo={getTagsFromTodo}
          cacheDragList={cacheDragList}
          setInfo={setInfo}
          setWarning={setWarning}
          setError={setError}
          getAreaById={getAreaById}
          createAttachment={createAttachment}
          deleteAttachment={deleteAttachment}
          editAttachment={editAttachment}
          downloadAttachment={downloadAttachment}
          getTodoAttachments={getTodoAttachments}
        />
      </PageTemplate>
    )
  }
)
